export default "__VITE_ASSET__DmeUqztI__"